import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import { authAxios } from '../../../API/apiRequest';
import { Button } from '../../../components/Button/Button';
import { FieldComponent } from '../AddJob/components/FieldComponent';
import { ListItems } from '../AddJob/components/ListItems';
import { EmployerLayout } from "../Layout/EmployerLayout"
import validator from 'validator'
import { LoadingEmployerJob } from '../Job/EmployerJob';
import { useDispatch } from 'react-redux';
import { update } from '../../../State/Slice/userSlice';

const CompanyInfo: React.FC = ()=>{
    const [error, setError] = useState<string | null>(null)
    const [saving, setSaving] = useState<boolean>(false)
    const [done, setDone] = useState<string | null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [userNumber, setUserNumber] = useState<string>('')
    const [name, setName] = useState<string>('')
    const [companyNumber, setCompanyNumber] = useState<string>('')
    const [email, setEmail] = useState<string>('')
    const [companyEmail, setCompanyEmail] = useState<string>('')
    const [addresses, setAddresses] = useState<string[]>([])
    const dispatch = useDispatch()



    useEffect(()=>{
        async function getData(){
            try{
                let result = await authAxios.get('/employer/info')
                setName(result.data.name)
                setEmail(result.data.email)
                setCompanyEmail(result.data.placeEmail)
                setUserNumber(result.data.phone)
                setCompanyNumber(result.data.placePhone)
                setAddresses(result.data.address.map((a: {id: string, location: string})=>a.location))
                setLoading(false)
            }catch(e){
                console.log(e)
                setError('حدث خطأ من فضلك قم بالمحاولة مرة اخري')
                setLoading(false)
            }
        }
        getData()
    },[])


    const onAddAddress = async(v: string)=>{
        if(v.trim() !== '' && !addresses.includes(v.trim())){
            try{
                let result = await authAxios.post('/employer/address', {address: v.trim()})
                if(result.status === 201)
                    setAddresses([...addresses, v.trim()])
            }catch(e){
                console.log(e)
                return 
            }
        }
     }
    const onSubmit = async()=>{
        try{
            if(name.split(' ').length < 2) return setError('الإسم غير صحيح من فضلك قم بكتابة الإسم ثنائي')
            if(!validator.isEmail(companyEmail)) return setError('البريد الإلكتروني غير صحيح')
            if(userNumber.trim().length < 10) return setError('رقم الهاتف غير صحيح')
            if(companyNumber.trim() === '') return setError('رقم الهاتف المكان غير صحيح')
            setSaving(true)
            setError('')
            let result = await authAxios.post('/employer/info', {
                phone: userNumber,
                placeEmail: companyEmail,
                placePhone: companyNumber,
                name
            })
            setSaving(false)
            if(result.status === 200){
                let json = await localStorage.getItem('user')
                if(json){
                    let user = await JSON.parse(json)
                    user.name = name
                    await localStorage.setItem('user', JSON.stringify(user))
                    dispatch(update({name}))
                }

                setDone('تم تحديث البيانات')
            }
            return
        }catch(e){
            console.log(e)
            setError('حدث خطأ من فضلك قم بالمحاولة مرة اخري')
            setSaving(false)
            return
        }
    }

    if(loading) return <LoadingEmployerJob />
    else
    return(
        <EmployerLayout>
        <Row>
          <FieldComponent 
              value={name} 
              onChangeValue={(v: string)=>{setName(v); setError('')}} 
              width={250} 
              title='اسم المسؤول عن الحساب' 
              placeholder='الإسم' 
            />
        </Row>
        <Row>
          <FieldComponent 
              value={userNumber} 
              onChangeValue={(v: string)=>{setUserNumber(v); setError('')}} 
              width={250} 
              title='رقم هاتف المسؤول عن الحساب' 
              placeholder='رقم الهاتف' 
            />
        </Row>
        <Row>
          <FieldComponent 
              value={email} 
              onChangeValue={()=>{setEmail(email)}} 
              width={250} 
              title='البريد الإلكتروني الخاص بالحساب' 
              placeholder='البريد الإلكتروني' 
              disabled
            />
        </Row>
        <Row>
          <FieldComponent 
              value={companyEmail} 
              onChangeValue={(v: string)=>{ setCompanyEmail(v); setError('')}} 
              width={250} 
              title='البريد الإلكتروني الخاص بمكان العمل' 
              placeholder='البريد الإلكتروني' 
            />
         </Row>
         <Row>
          <FieldComponent 
              value={companyNumber} 
              onChangeValue={(v: string)=>{ setCompanyNumber(v); setError('')}} 
              width={250} 
              title='هاتف مكان العمل' 
              placeholder='الهاتف' 
            />
        </Row>
         <Row style={{marginTop: 10}}>
            <Col style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end'}}>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <p style={{textAlign: 'right', color: '#fff', fontWeight: 'bold', marginBottom: 10, padding: 0}}>العناوين</p>
                </div>
                <ListItems onAdd={onAddAddress} data={addresses} />
            </Col>
        </Row>
        <Row style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <p style={{color: 'tomato', textAlign: 'center', fontSize: 16, marginTop: 15, marginBottom: 0}}>{error && error}</p>
          <p style={{color: 'rgb(10,230,10)', textAlign: 'center', fontSize: 16, marginTop: 15, marginBottom: 0}}>{done && done}</p>
          <Button
            loading={saving} 
            style={{marginBottom: 25, marginTop: 25}} 
            height={60} 
            onPress={onSubmit}
            color='#1D8C49'
            hoverColor='#0e6b33'
            >حفظ</Button>
        </Row>
        </EmployerLayout>
    )
}

export default CompanyInfo